import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import axios from 'axios';
import VueTippy from "vue-tippy";
import Vuelidate from 'vuelidate';
import VueToast from 'vue-toast-notification';
import VueSweetalert2 from 'vue-sweetalert2';
import VueAnalytics from 'vue-analytics';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'vue-toast-notification/dist/theme-default.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSocketIO from 'vue-socket.io'

Vue.use(VueTippy);

Vue.use(Vuelidate);
Vue.use(VueToast);
Vue.use(VueSweetalert2);

// Vue.use(VueAnalytics, {
//   id: 'UA-202496493-1',

//   router
// });
//https:stagingv2.insurancebazaar.o3zoned.com/api/
// https://live.insurancebazaar.o3zoned.com/
// axios.defaults.baseURL = 'http://localhost/ozoned-d2c-laravel5.8/api/';3
axios.defaults.baseURL = 'https://live.insurancebazaar.o3zoned.com/api/';
// axios.defaults.baseURL = 'http://d2c-group9.test/api/';
// axios.defaults.baseURL = 'https://customerweb.neem.ozonedlite.com/';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = '*/*';
axios.defaults.headers.common['distribution'] = 'd2c';

let baseURL = axios.defaults.baseURL;
localStorage.setItem("baseURL", baseURL);

axios.interceptors.response.use(function (response) {
  if (response.data.code === 422 && response.data.message.includes("Unauthorized")) {
    store.dispatch('LogOut')
    $toast.error('User Unauthorized!!', { position: 'top-right' });
    router.push('/')
    location.reload();
  }
  return response
}, function (error) {
  return Promise.reject(error)
})

let paymentRedirect = store.getters.getQuotationPayment;
if (!paymentRedirect) {
  store.commit('resetQuotationData');
}

let access_token = store.getters.getLoginUserToken;
if (access_token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
  localStorage.setItem('UserToken', `Bearer ${access_token}`)
  store.dispatch('updateUserInfo');
}

//UMER RASHEED
function appendMessage (payload) {
  let t_notifications = $('.t-new-notifications').text();

  t_notifications=Number(t_notifications.replace(/\s/g, ''))+Number(1);
  // $('.t-new-notifications').show();
  // $('.t-new-notifications').text(t_notifications);
  // $('.ul-new-notification').prepend('<li> <a href="'+(payload.notification.click_action !==undefined?payload.notification.click_action:"javascript:;")+'"> <span class="photo"> <img alt="" class="img-circle" src=""> </span>  <span class="details">  '+(payload.notification.body !==""?payload.notification.body:payload.notification.title)+' <span class="time">just now</span></span> </a> </li>');
  // $('.ul-new-notification').prepend('<li> <a href="javascript:;"> <span class="time">just now</span> <span class="details"> <span class="label label-sm label-icon label-success">  </span> '+(payload.notification.body !==""?payload.notification.body:payload.notification.title)+' </span> </a> </li>');
  return;
  const messagesElement = document.querySelector('#messages');
  const dataHeaderELement = document.createElement('h5');
  const dataElement = document.createElement('pre');
  dataElement.style = 'overflow-x:hidden;';
  dataHeaderELement.textContent = 'Received message:';
  dataElement.textContent = JSON.stringify(payload, null, 2);
  messagesElement.appendChild(dataHeaderELement);
  messagesElement.appendChild(dataElement);
}

function LoadNotifications () {
  var token = localStorage.getItem("UserToken");
  var Count = localStorage.getItem('NotificationPaginate');

  $.ajax({
    url: baseURL + 'customer/notifications/user_notifications?current_page=1&paginate=yes&order_sort=desc&per_page=' + Count,
    type: 'GET',
    contentType: "application/x-www-form-urlencoded; charset=urf-8",
    dataType: 'json',
    beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', `Bearer ${token}`); },
    data: {},
    cache: false,
    success: function (result) {
      let notifications = result.data.notifications;
      let is_read = 0;
      if(notifications) {
        for(let i = 0 ; i < notifications.length ; i++) {
          if(notifications[i].is_read === 0) {
            is_read++;
          }
        }
      }
      if (is_read > 9) {
        $('#notificationCounter').html('9+');
      } else {
        $('#notificationCounter').html(is_read);
      }
    }, error: function () {
      console.log('Error');
    },
    timeout: 3000
  }).fail(function (jqXHR, textStatus) {
    if (textStatus === 'timeout') {
      console.log('Sorry!Please Wait... Slow connection!');
    }
  });
}

//staging
var config = {
  apiKey: "AIzaSyDZ9hW-FYajTx7uoJueSf6v3QCB59hFEcQ",
  authDomain: "insurance-bazaar-dev.firebaseapp.com",
  projectId: "insurance-bazaar-dev",
  storageBucket: "insurance-bazaar-dev.appspot.com",
  messagingSenderId: "491187917281",
  appId: "1:491187917281:web:f334cd61fd57f7889b42a0",
  measurementId: "G-79CFB97DLV"
};

//live
// var config = {
//   apiKey: "AIzaSyAAU0rGLPQ15qmMI4lNRZG6H3lq3g7g-Sw",
//   authDomain: "insurance-bazaar-f2455.firebaseapp.com",
//   projectId: "insurance-bazaar-f2455",
//   storageBucket: "insurance-bazaar-f2455.appspot.com",
//   messagingSenderId: "576846594161",
//   appId: "1:576846594161:web:aa4cec8a283f598b6a9bd0",
//   measurementId: "G-X754T25EM3"
// };

if(firebase.messaging.isSupported()) {

  firebase.initializeApp(config);
  const messaging = firebase.messaging();

  if('serviceWorker' in navigator) {
    navigator.serviceWorker.register('../firebase-messaging-sw.js').then(function(registration) {
      console.log("Service Worker Registered");
      messaging.useServiceWorker(registration);
    });
  }

  messaging.onMessage((payload) => {
    console.log('meassage received');
    console.log(payload);
    appendMessage(payload);
    let isAuthenticated = store.getters.isAuthenticated;
    if (isAuthenticated) {
      LoadNotifications();
    }

    if(payload.data.notification_type == 'email_verified') {
      store.commit('setEmailVerified');
    }
  });

  messaging.requestPermission().then(function () {
    console.log('Notification permission granted.');
    messaging.getToken({ vapidKey: 'BAlc32VcNRWZrDFBUBvtiBqaYrgFUBoAqzbVCxGcUW0qUXxSSUuMGCf-uN5bk6_5PUs5Im6acfN07x5aPhGJeXY' }).then((currentToken) => { //staging
    // messaging.getToken({ vapidKey: 'BBVhS7eTJ7DIM51BPuWtgrUh5fQ3NkVtzoMm-EbzcbYLoInvzTqT3QK3HNDJCWmTE1nr7du6SUl1vQ4LPyq_VvI' }).then((currentToken) => { //live
      if(currentToken) {
        if(currentToken === undefined) {
          currentToken = localStorage.getItem('FCMToken');
        } else {
          localStorage.setItem('FCMToken', currentToken);
        }

        //Update Token Api
        let token = localStorage.getItem("UserToken");
        let baseURL = localStorage.getItem("baseURL");

        console.log('Sending token to server...');
        $.ajax({
          url: baseURL + 'customer/update_device_token',
          type: 'POST',
          contentType: "application/x-www-form-urlencoded; charset=urf-8",
          dataType: 'json',
          beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', token); },
          data: {
            device_id: Math.floor(999999999999 + Math.random() * 900066666699999999999),
            platform: 'web',
            device_token: currentToken,
            user_type: 'customer'
          },
          cache: false,
          success: function (result) {
            console.log('Token sent to server...');
            localStorage.setItem('FCMToken', currentToken);
          }, error: function () {
            console.log('Error');
          },
          timeout: 3000
        }).fail(function (jqXHR, textStatus) {
          if (textStatus === 'timeout') {
            console.log('Sorry!Please Wait... Slow connection!');
          }
        });
      } else {
        console.log('No registration token available. Request permission to generate one.');
      }
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
  }).catch(function (err) {
    console.log('Unable to get permission to notify. ', err);
  });
}

Vue.use(new VueSocketIO({
  debug: true,
  connection: 'https://staging.insurancebazaar.o3zoned.com:8888/',
  vuex: {
    store,
  }
}))
//END -------------------------

window.$toast = Vue.$toast;
window.$ = window.jQuery = require('jquery');
window.axios = axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  el: "#app"
});



// WEBPACK FOOTER //
// ./src/main.js